/**
 * Job code shown in the field app. Settings → Features → "Short job codes"
 * switches between the new LX-219 / LC-1074 codes and the current job number
 * (first segment of the long project_ref: LUX219 / LC1074).
 */
export const legacyJobCode = (projectRef) => (projectRef || '').split('-')[0].trim() || null;

export const jobCode = (item, features) => {
  if (!item) return '';
  const short = features?.short_project_codes ? item.project_code : null;
  return short || legacyJobCode(item.project_ref) || item.project_code || '';
};

export const isConstruction = (item) => /^(LC)/i.test(item?.project_code || item?.project_ref || '');
